import { WindowTitle } from "@saleor/components/WindowTitle";
import { sectionNames } from "@saleor/intl";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, RouteComponentProps, Switch } from "react-router";

import {
  productActivationSettingPath,
  ProductActivationSettingUrlQueryParams
} from "./urls";
import ProductActivationSettingComponent from "./views/ProductActivationSetting";

const productActivationSetting: React.FC<RouteComponentProps<{}>> = ({
  location
}) => {
  const qs = parseQs(location.search.substr(1));
  const params: ProductActivationSettingUrlQueryParams = qs;
  return <ProductActivationSettingComponent params={params} />;
};
export const ProductActivationSettingSection: React.FC = () => {
  const intl = useIntl();
  return (
    <>
      <WindowTitle
        title={intl.formatMessage(sectionNames.productActivationSetting)}
      />
      <Switch>
        <Route
          exact
          path={productActivationSettingPath}
          component={productActivationSetting}
        />
      </Switch>
    </>
  );
};
export default ProductActivationSettingSection;
